<template>
  <div>
  <V2Home v-if="$route.query.design === 'v2'" :home="home" />
  <layout v-else>
    <!-- 简介 -->
    <Introduction
      :data="home.introduction"
    />

    <News :data="home.news"  id="news" />

    <!-- 赛题说明 -->
    <Note :data="home.note" />

    <!-- 日程 -->
    <Schedule :data="home.schedule" />

    <!-- 奖项设置 -->
    <Prize :data="home.prize"></Prize>

    <!-- 特邀学术顾问 -->
    <Judges :data="home.judges"></Judges>

    <!-- 赛道评委 -->
    <!-- <JudgeSaidao :data="home.judgeSaidao" /> -->

    <!-- 视频 -->
    <div class="section" id="videos">
      <div class="layout-content">
        <SubTitle :text="home.videos.titleCh" :subText="home.videos.titleEn" />
        <TrainingList :data="home.videos" />
      </div>
    </div>

    <!-- 合作伙伴 Logo 墙 -->
    <PartnerLogos />

    <!-- 合作伙伴 -->
    <Partners :data="home.partners" />

    <!-- 左侧 bar -->
    <transition name="gk-slide-in" v-if="!isMobile">
      <WeBar
        :bars="home.bars"
        :qrcodeList="home.barQrcodeList"
        v-if="showBar"
      />
    </transition>

  </layout>
  </div>
</template>

<script>
import layout from '../../components/layout/layout'
import TrainingList from '../../components/TrainingList'
import SubTitle from '../../components/SubTitle'
import Introduction from './Introduction'
import Note from './Note'
import Schedule from './Schedule'
// import JudgeSaidao from './JudgeSaidao'
import News from './News'
import Prize from './Prize'
import Judges from './Judges'
import PartnerLogos from './PartnerLogos'
import Partners from './Partners'
import WeBar from './We.Bar'
import V2Home from './V2Home'

import VueBus from '@/utils/vueBus'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      showBar: false,
      eachBranchScroll: []
    }
  },
  name: 'Home',
  components: {
    V2Home,
    layout,
    Introduction,
    Note,
    Schedule,
    Prize,
    Judges,
    PartnerLogos,
    // JudgeSaidao,
    TrainingList,
    News,
    SubTitle,
    Partners,
    WeBar
  },
  created () {
    // this.home = this.$t('home')
  },
  methods: {
    /**
     * 获取所有分会元素相对屏幕中线的位置 [when scrollTop === 0]
     */
    getBranchClientRect () {
      const pageScrollTop = document.documentElement.scrollTop
      const clientHeight = document.documentElement.clientHeight

      const branches = document.querySelectorAll('.section')
      branches.forEach(ele => {
        // 因为页面会记住上一次的滚动位置，所以要去除掉 scrollTop 的偏移量
        this.eachBranchScroll.push(ele.getBoundingClientRect().top - clientHeight / 2 + pageScrollTop + 1000)
      })
    },
    /**
     * 监听页面 scrollTop 值, 获取进入屏幕中线的 branch 的 index
     */
    listenActiveIndex () {
      const pageScrollTop = document.documentElement.scrollTop

      let index = 0
      while (pageScrollTop > this.eachBranchScroll[index]) {
        ++index
      }
      // index -= 1

      VueBus.$emit('setTargetIndex', index)

      if (pageScrollTop > document.body.clientWidth * 0.4) {
        this.showBar = true
      } else {
        this.showBar = false
      }
    },

    scrollToTargetBranchHandler (id) {
      window.removeEventListener('scroll', this.listenActiveIndex)
      this.$scrollTo(`${id}`, 500, {
        offset: this.scrollOffset,
        onDone: () => {
          window.addEventListener('scroll', this.listenActiveIndex)
        }
      })
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    scrollOffset () {
      return this.isMobile ? -55 : -90
    },
    home () {
      return this.$t('home')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listenActiveIndex)

    VueBus.$on('scrollToTargetBranch', this.scrollToTargetBranchHandler)

    this.getBranchClientRect()
  },

  beforeDestroy () {
    VueBus.$off('scrollToTargetBranch', this.scrollToTargetBranchHandler)
  }
}
</script>
